import { render, staticRenderFns } from "./HeroSoftware.vue?vue&type=template&id=6779b35f&scoped=true&"
import script from "./HeroSoftware.vue?vue&type=script&lang=js&"
export * from "./HeroSoftware.vue?vue&type=script&lang=js&"
import style0 from "./HeroSoftware.vue?vue&type=style&index=0&id=6779b35f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779b35f",
  null
  
)

export default component.exports